import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable} from 'rxjs';

import { environment } from 'src/environments/environment';
import { User, ActivationRequest } from '../models';
import { ErrorToken, createCustomErrorContext } from 'src/app/core/interceptors/generic-error-handling-interceptors';
import { IPbxUser } from 'voxloud-types/dist/models';

@Injectable()
export class UsersService {
  constructor(private http: HttpClient) {}

  getUsers(id: number): Observable<User[]> {
    return this.http.get<User[]>(`${environment.apiEndpoint}/api/v2/companies/${id}/users`);
  }

  addUser(companyId: number, user: User, errorToken?: ErrorToken[]) {
    const data = {...user};
    delete data._isEditing;
    delete data._isDeleting;
    return this.http.post(
      `${environment.apiEndpoint}/api/v2/companies/${companyId}/users`,
      data,
      errorToken ? { context: createCustomErrorContext(errorToken) } : undefined
      );
  }

  editUser(companyId: number, user: User, errorToken?: ErrorToken[]) {
    const data = {...user};
    delete data._isEditing;
    delete data._isDeleting;
    return this.http.put(
      `${environment.apiEndpoint}/api/v2/companies/${companyId}/users/${user.userId}`,
      data,
      errorToken ? { context: createCustomErrorContext(errorToken) } : undefined
      )
  }

  deleteUser(companyId: number, userId: number){
    return this.http.delete<User[]>(`${environment.apiEndpoint}/api/v2/companies/${companyId}/users/${userId}`);
  }

  activateUser(r: ActivationRequest) {
    return this.http.post(`${environment.apiEndpoint}/api/accountactivationform`, r);
  }

  resetPresence(pbxId: number, userId: string) {
    return this.http.put(`${environment.apiEndpoint}/api/v1/pbxes/${pbxId}/users/${userId}/extension/reset-presence-state`, {});
  }

  getUsersFromPbxById(pbxId: number): Observable<IPbxUser[]> {
    return this.http.get<IPbxUser[]>(`${environment.apiEndpoint}/api/v1/pbxes/${pbxId}/users`);
  }

  syncPasswords(companyId: number): Observable<void> {
    return this.http.post<void>(`${environment.apiEndpoint}/api/v1/chat/users/passwords/sync`, {}, {
      headers: {
        'Voverc-Company-ID': String(companyId)
      }
    });
  }
}